import employeeapi from "../../../services/employee";
import { toLocalDateKey } from "../../../utils/date";

export const fetchEmployeesApi = async (branchId, year, month) => {
  const response = await employeeapi.get(`Employees/by-branch/${branchId}?year=${year}&month=${month}`);
  return response.data;
};

export const downloadResignationForm = async (employeeId, hireDate, exitDate, storeAddress = "") => {
  const response = await employeeapi.post(
    "Employees/resignation-form",
    { employeeId, hireDate, exitDate, storeAddress },
    { responseType: "blob" }
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;

  let fileName = "Istifa_Formu.docx";
  const disposition = response.headers["content-disposition"];
  if (disposition && disposition.indexOf("filename=") !== -1) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
    if (matches != null && matches[1]) fileName = matches[1].replace(/['"]/g, "");
  }

  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const fetchJobsApi = async () => {
  const response = await employeeapi.get("Jobs/no-paginate");
  return response.data;
};

export const updateEmployeeJobApi = async (employeeId, jobId) => {
  const response = await employeeapi.put(`Employees/${employeeId}/job`, { jobId });
  return response.data;
};

export const updateBulkEmployeeJobsApi = async (jobUpdates) => {
  const response = await employeeapi.put("Employees/bulk/job/by-store-manager", {
    items: jobUpdates,
  });
  return response.data;
};

// Employee Leaves Endpoints
export const createEmployeeLeaveApi = async (employeeId, reason, workDate) => {
  const payload = {
    employeeId,
    reason,
    leaveDate: workDate || toLocalDateKey(),
  };
  const response = await employeeapi.post("EmployeeLeaves", payload);
  return response.data;
};

export const updateEmployeeLeaveApi = async (id, reason) => {
  const response = await employeeapi.put(`EmployeeLeaves/${id}`, { id, reason });
  return response.data;
};

export const deleteEmployeeLeaveApi = async (id) => {
  const response = await employeeapi.delete(`EmployeeLeaves/${id}`);
  return response.data;
};

export const fetchEmployeeLeavesByBranchApi = async (branchId, startDate, endDate) => {
  const today = toLocalDateKey();
  const startParam = startDate || today;
  const endParam = endDate || today;
  const response = await employeeapi.get(`EmployeeLeaves/by-branch/${branchId}/${startParam}/${endParam}`);
  return response.data;
};
